import $ from 'jquery';
import Modal from './Modal';
import Form from './Form';
import target from './target'

window.shopOrdercall = {
	Modal,
	Form
};

let getMask = function () {
	let result = null;

	window.shopOrdercallConfig.form_fields.forEach((field) => {
		if (field.type === 'tel') {
			if (field.mask) {
				result = field.mask;
			}
		}
	});

	return result;
};

let createButton = function () {
	const $button = $(window.shopOrdercallConfig.button_html);

	$button.filter('.ordercall-smart-button').each((idx, button) => {
		const $button = $(button);
		const $button_text = $button.filter('.ordercall-smart-button_text');
		const $form = $button.filter('.ordercall-smart-button_form');

		if ($button_text.length !== 0)
		{
			$button_text.on('click', () => {
				target('smart_button_click');
				Modal.open();
			});
		}
		else if ($form.length !== 0)
		{
			const mask = getMask();
			const $input = $button.find('.ordercall-smart-button__input');
			const hide = () => {
				$button.addClass('ordercall-smart-button_hidden');
			};

			if (mask) {
				$input.mask(mask);
			}

			$form.on('submit', (e) => {
				e.preventDefault();

				if ($input.val().length === 0) {
					$input.focus();
					return;
				}

				target('smart_button_send');

				Form.sendData($button.serialize() + '&button_bot_hash=' + window.shopOrdercallConfig.button_bot_hash, (r) => {
					Modal.open();

					if (r.status === 'fail' || r.errors !== undefined) {
						if (r.errors[0] === 'Already exist') {
							Form.fail('Вы уже отправляли заявку');
							return;
						}

						Form.fail();
						return;
					}

					Form.success(r.data);
					hide();
				}, () => {
					Modal.open();
					Form.fail();
				});
			});
		}
		else
		{
			$button.find('.ordercall-smart-button__button').on('click', () => {
				target('smart_button_click');
				Modal.open();
			});
		}
	});

	$(document.body).append($button);
};

$(() => {
	let mobileEnabled = window.shopOrdercallConfig.smart_button_mobile_is_enabled;

	if (window.shopOrdercallActionUrl) {
		window.shopOrdercallConfig.action = window.shopOrdercallActionUrl;
	}

	let $oc_call_back_button;

	if (shopOrdercallConfig) {
		$oc_call_back_button = $(shopOrdercallConfig.form_tag_class);
	} else {
		$oc_call_back_button = $();
	}

	$oc_call_back_button.on('click', function (event) {
		event.preventDefault();
		Modal.open();
	});

	$.mask.definitions['9'] = '';
	$.mask.definitions['#'] = '[0-9]';

	if(!isMobile() || !(mobileEnabled === "0")) {
		createButton();
	}

	Form.fillOrdercallUserSpecifiedFields();

	function isMobile() {
		let check = false;
		(function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
		return check;
	};
});


// WEBPACK FOOTER //
// ./src/webpack/frontend/ordercall/index.js